//#region Libraries
import { TitleSection } from "components/styles";
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    width: 68vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    & ${TitleSection} {
        width: 100%;
    }
`;